import React from 'react';
import ScrollAnimation from '../components/ScrollAnimation';
import './TermsOfUse.css';

const TermsOfUse = () => {
  return (
    <div className="terms-of-use-page">
      <section className="terms-of-use-hero section">
        <div className="container">
          <ScrollAnimation delay={0}>
            <h1 className="page-title">Terms of Use</h1>
          </ScrollAnimation>
          <ScrollAnimation delay={200}>
            <p className="page-subtitle">
              Guidelines and rules for using CableBiz platform and services
            </p>
          </ScrollAnimation>
        </div>
      </section>

      <section className="terms-of-use-content section">
        <div className="container">
          <div className="legal-content">
            <ScrollAnimation delay={0}>
              <div className="legal-section">
                <h2>1. Agreement to Terms</h2>
                <p>
                  These Terms of Use ("Terms") constitute a legally binding agreement between you and Neeladri Software 
                  Solutions Pvt Ltd Private Limited ("Company", "we", "us", or "our") governing your access to and use 
                  of the CableBiz website, mobile applications, and related services (collectively, the "Service").
                </p>
                <p>
                  By accessing or using CableBiz, you agree to be bound by these Terms. If you disagree with any part 
                  of these Terms, you may not access or use the Service.
                </p>
              </div>
            </ScrollAnimation>

            <ScrollAnimation delay={100}>
              <div className="legal-section">
                <h2>2. Use License</h2>
                <p>
                  Subject to your compliance with these Terms, we grant you a limited, non-exclusive, non-transferable, 
                  revocable license to access and use CableBiz for your internal business purposes in accordance with 
                  your subscription plan.
                </p>
                <p>This license does not include the right to:</p>
                <ul>
                  <li>Resell or sublicense the Service</li>
                  <li>Use the Service for any illegal or unauthorized purpose</li>
                  <li>Modify, adapt, or hack the Service</li>
                  <li>Reverse engineer or attempt to extract source code</li>
                  <li>Remove any proprietary notices or labels</li>
                </ul>
              </div>
            </ScrollAnimation>

            <ScrollAnimation delay={200}>
              <div className="legal-section">
                <h2>3. Acceptable Use Policy</h2>
                <p>You agree to use CableBiz only for lawful purposes and in a way that does not infringe the rights 
                of others or restrict their use of the Service. Specifically, you agree not to:</p>
                
                <h3>3.1 Prohibited Activities</h3>
                <ul>
                  <li>Violate any applicable local, state, national, or international law</li>
                  <li>Transmit any material that is abusive, harassing, defamatory, or obscene</li>
                  <li>Impersonate any person or entity or falsely state your affiliation</li>
                  <li>Upload or transmit viruses, malware, or any malicious code</li>
                  <li>Interfere with or disrupt the Service or servers</li>
                  <li>Attempt to gain unauthorized access to any portion of the Service</li>
                  <li>Use automated systems (bots, scrapers) to access the Service without permission</li>
                  <li>Collect or harvest information about other users without consent</li>
                  <li>Use the Service to send spam or unsolicited communications</li>
                </ul>
              </div>
            </ScrollAnimation>

            <ScrollAnimation delay={300}>
              <div className="legal-section">
                <h2>4. User Content and Data</h2>
                <h3>4.1 Your Content</h3>
                <p>
                  You retain ownership of any data, content, or information you upload, submit, or store through CableBiz 
                  ("User Content"). By using the Service, you grant us a worldwide, non-exclusive, royalty-free license 
                  to use, store, and process your User Content solely for the purpose of providing and improving the Service.
                </p>

                <h3>4.2 Your Responsibilities</h3>
                <p>You are solely responsible for:</p>
                <ul>
                  <li>The accuracy, quality, and legality of your User Content</li>
                  <li>Obtaining necessary rights and permissions for your User Content</li>
                  <li>Ensuring your User Content does not violate any third-party rights</li>
                  <li>Backing up your data regularly</li>
                </ul>

                <h3>4.3 Content Monitoring</h3>
                <p>
                  We reserve the right to monitor, review, and remove any User Content that violates these Terms or is 
                  otherwise objectionable, but we are not obligated to do so.
                </p>
              </div>
            </ScrollAnimation>

            <ScrollAnimation delay={400}>
              <div className="legal-section">
                <h2>5. Account Security</h2>
                <p>You are responsible for maintaining the confidentiality of your account credentials and for all 
                activities that occur under your account. You agree to:</p>
                <ul>
                  <li>Use a strong, unique password</li>
                  <li>Not share your account credentials with others</li>
                  <li>Immediately notify us of any unauthorized access or security breach</li>
                  <li>Log out of your account when using shared devices</li>
                  <li>Use two-factor authentication when available</li>
                </ul>
                <p>
                  We are not liable for any loss or damage arising from your failure to protect your account credentials.
                </p>
              </div>
            </ScrollAnimation>

            <ScrollAnimation delay={500}>
              <div className="legal-section">
                <h2>6. Service Modifications and Availability</h2>
                <p>
                  We reserve the right to modify, suspend, or discontinue any part of the Service at any time, with or 
                  without notice. We may also impose limits on certain features or restrict access to parts of the Service 
                  without notice or liability.
                </p>
                <p>
                  While we strive to maintain high availability, we do not guarantee that the Service will be available 
                  at all times or that it will be error-free. The Service may be unavailable due to:
                </p>
                <ul>
                  <li>Scheduled maintenance</li>
                  <li>System upgrades</li>
                  <li>Technical issues or failures</li>
                  <li>Force majeure events</li>
                </ul>
              </div>
            </ScrollAnimation>

            <ScrollAnimation delay={600}>
              <div className="legal-section">
                <h2>7. Intellectual Property</h2>
                <p>
                  The Service and its original content, features, and functionality are owned by Neeladri Software Solutions 
                  Pvt Ltd Private Limited and are protected by Indian and international copyright, trademark, patent, 
                  trade secret, and other intellectual property laws.
                </p>
                <p>
                  The CableBiz name, logo, and related marks are trademarks of Neeladri Software Solutions Pvt Ltd Private 
                  Limited. You may not use our trademarks without our prior written permission.
                </p>
                <p>
                  You acknowledge that the Service contains proprietary and confidential information. You agree not to 
                  disclose, copy, or use any such information except as expressly permitted by these Terms.
                </p>
              </div>
            </ScrollAnimation>

            <ScrollAnimation delay={700}>
              <div className="legal-section">
                <h2>8. Third-Party Services and Links</h2>
                <p>
                  CableBiz may integrate with or link to third-party services, websites, or applications. We do not 
                  endorse or assume responsibility for any third-party content, products, or services.
                </p>
                <p>
                  Your interactions with third-party services are solely between you and the third party. We are not 
                  liable for any loss or damage resulting from such interactions.
                </p>
              </div>
            </ScrollAnimation>

            <ScrollAnimation delay={800}>
              <div className="legal-section">
                <h2>9. Disclaimer of Warranties</h2>
                <p>
                  THE SERVICE IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF ANY KIND, EITHER EXPRESS OR 
                  IMPLIED, INCLUDING BUT NOT LIMITED TO IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR 
                  PURPOSE, AND NON-INFRINGEMENT.
                </p>
                <p>
                  We do not warrant that:
                </p>
                <ul>
                  <li>The Service will meet your specific requirements</li>
                  <li>The Service will be uninterrupted, timely, secure, or error-free</li>
                  <li>The results obtained from using the Service will be accurate or reliable</li>
                  <li>Any errors in the Service will be corrected</li>
                </ul>
              </div>
            </ScrollAnimation>

            <ScrollAnimation delay={900}>
              <div className="legal-section">
                <h2>10. Limitation of Liability</h2>
                <p>
                  TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, IN NO EVENT SHALL NEELADRI SOFTWARE SOLUTIONS PVT 
                  LTD PRIVATE LIMITED, ITS DIRECTORS, EMPLOYEES, OR AGENTS BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, 
                  CONSEQUENTIAL, OR PUNITIVE DAMAGES, INCLUDING BUT NOT LIMITED TO LOSS OF PROFITS, DATA, USE, GOODWILL, 
                  OR OTHER INTANGIBLE LOSSES, RESULTING FROM YOUR USE OR INABILITY TO USE THE SERVICE.
                </p>
                <p>
                  Our total liability for any claims arising from or related to the Service shall not exceed the amount 
                  you paid to us in the twelve (12) months preceding the claim, or ₹10,000 (Indian Rupees Ten Thousand), 
                  whichever is greater.
                </p>
              </div>
            </ScrollAnimation>

            <ScrollAnimation delay={1000}>
              <div className="legal-section">
                <h2>11. Indemnification</h2>
                <p>
                  You agree to defend, indemnify, and hold harmless Neeladri Software Solutions Pvt Ltd Private Limited, 
                  its affiliates, officers, directors, employees, and agents from and against any claims, damages, 
                  obligations, losses, liabilities, costs, or debt, and expenses (including attorney's fees) arising from:
                </p>
                <ul>
                  <li>Your use of the Service</li>
                  <li>Your violation of these Terms</li>
                  <li>Your violation of any third-party rights</li>
                  <li>Your User Content</li>
                </ul>
              </div>
            </ScrollAnimation>

            <ScrollAnimation delay={1100}>
              <div className="legal-section">
                <h2>12. Termination</h2>
                <p>
                  We may terminate or suspend your account and access to the Service immediately, without prior notice, 
                  for any reason, including breach of these Terms. Upon termination:
                </p>
                <ul>
                  <li>Your right to use the Service will immediately cease</li>
                  <li>We may delete your account and data</li>
                  <li>All provisions of these Terms that by their nature should survive termination shall survive</li>
                </ul>
                <p>
                  You may terminate your account at any time by contacting our support team. Termination does not 
                  relieve you of any obligations accrued prior to termination.
                </p>
              </div>
            </ScrollAnimation>

            <ScrollAnimation delay={1200}>
              <div className="legal-section">
                <h2>13. Governing Law and Jurisdiction</h2>
                <p>
                  These Terms shall be governed by and construed in accordance with the laws of India, without regard 
                  to its conflict of law provisions. Any disputes arising from these Terms or your use of the Service 
                  shall be subject to the exclusive jurisdiction of the courts in Bhubaneswar, Odisha, India.
                </p>
              </div>
            </ScrollAnimation>

            <ScrollAnimation delay={1300}>
              <div className="legal-section">
                <h2>14. Changes to Terms of Use</h2>
                <p>
                  We reserve the right to modify these Terms at any time. We will notify users of material changes by:
                </p>
                <ul>
                  <li>Posting the updated Terms on our website</li>
                  <li>Sending email notifications to registered users</li>
                  <li>Updating the "Last Updated" date</li>
                </ul>
                <p>
                  Your continued use of the Service after such modifications constitutes your acceptance of the updated Terms.
                </p>
              </div>
            </ScrollAnimation>

            <ScrollAnimation delay={1400}>
              <div className="legal-section">
                <h2>15. Severability</h2>
                <p>
                  If any provision of these Terms is found to be unenforceable or invalid, that provision shall be 
                  limited or eliminated to the minimum extent necessary, and the remaining provisions shall remain in 
                  full force and effect.
                </p>
              </div>
            </ScrollAnimation>

            <ScrollAnimation delay={1500}>
              <div className="legal-section">
                <h2>16. Entire Agreement</h2>
                <p>
                  These Terms, together with our Privacy Policy and Terms & Conditions, constitute the entire agreement 
                  between you and Neeladri Software Solutions Pvt Ltd Private Limited regarding your use of CableBiz 
                  and supersede all prior agreements and understandings.
                </p>
              </div>
            </ScrollAnimation>

            <ScrollAnimation delay={1600}>
              <div className="legal-section">
                <h2>17. Contact Information</h2>
                <p>
                  If you have any questions about these Terms of Use, please contact us:
                </p>
                <div className="contact-info">
                  <p><strong>Email:</strong> info@nldsoft.com</p>
                  <p><strong>Support:</strong> support@nldsoft.com</p>
                  <p><strong>Address:</strong> Plot No: 52, Bapujinagar, Bhubaneswar, Odisha, India - 751009</p>
                </div>
              </div>
            </ScrollAnimation>

            <ScrollAnimation delay={1700}>
              <div className="legal-section">
                <p className="last-updated">
                  <strong>Last Updated:</strong> {new Date().toLocaleDateString('en-IN', { year: 'numeric', month: 'long', day: 'numeric' })}
                </p>
              </div>
            </ScrollAnimation>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsOfUse;


